import { FC } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { Customer } from 'containers/invoices/invoices.model';
import InvoiceCustomer from 'containers/invoices/create-invoice/components/InvoiceCustomer';
import { selectInvoiceCustomerEditPage, updateInvoiceCustomerEditPage } from '../invoicesEditSlice';

interface EditInvoiceCustomerProps {
  className?: string;
  context: React.Context<any>;
}

const EditInvoiceCustomer: FC<EditInvoiceCustomerProps> = ({ context }) => {
  const selectedCustomer = useAppSelector(selectInvoiceCustomerEditPage);

  const dispatch = useAppDispatch();

  const onUpdateServiceAddress = address => {
    const currentCustomer: Customer = { ...selectedCustomer, serviceAddress: address ? [address] : [] };
    dispatch(updateInvoiceCustomerEditPage(currentCustomer));
  };

  const onUpdateCustomer = customer => {
    dispatch(updateInvoiceCustomerEditPage(customer));
  };

  const onUpdateBillingAddress = address => {
    const currentCustomer: Customer = { ...selectedCustomer, billingAddress: address };
    dispatch(updateInvoiceCustomerEditPage(currentCustomer));
  };

  return (
    <div>
      <InvoiceCustomer
        isInvoiceEdit={true}
        selectedBillingAddress={selectedCustomer?.billingAddress}
        selectedCustomer={selectedCustomer}
        selectedServiceAddress={selectedCustomer?.serviceAddress?.[0]}
        onUpdateBillingAddress={onUpdateBillingAddress}
        onUpdateCustomer={onUpdateCustomer}
        onUpdateServiceAddress={onUpdateServiceAddress}
        context={context}
      />
    </div>
  );
};

export default EditInvoiceCustomer;
